import * as React from 'react';
import { OptionsPanel } from './options-panel/options-panel';
import { PanelsProps } from './types';
import { sfNames, sfParameters } from './sf-names';
import { manageOptionsUnit } from 'app/area/shared/manage-options';
import { AdminPaperTopPanel } from 'app/area/administration/edit/components';
import { groupSelectorFieldName } from 'app/components/access-panel/options-panel/options-panel.utils';
import { ComplexValue } from 'ui';
import get from 'lodash/get';
import { selectedGroupText } from 'app/components/access-panel/shared/selected-group-text';

export const Notifications = (props: PanelsProps) => {
  const { translation, readOnly, data, formComponent, formValues, endpoints, validation, clearValueInStore,
    roleSelected, roleBasedData, fetchingRoleBasedData, accessData, updateAccessData, clearValidation,
    options, loadOptions } = props;

  const groupSelectorName = groupSelectorFieldName(sfNames.responsibleForUnits, sfParameters.application);
  const selectedGroup = get(formValues, groupSelectorName) as ComplexValue<number>;

  return <AdminPaperTopPanel
    title={translation.responsible_for_unassigned_cases_and_actions}>
    <OptionsPanel
      readOnly={readOnly}
      translation={translation}
      initialValue={data && data.responsibleForUnits}
      roleSelected={roleSelected}
      roleValue={roleBasedData && roleBasedData.responsibleForUnits}
      accessData={accessData && accessData.responsibleForUnits}
      updateAccessData={updateAccessData}
      fetchingRoleValue={fetchingRoleBasedData}
      formComponent={formComponent}
      formValues={formValues}
      formName={sfNames.responsibleForUnits}
      groupingName={sfParameters.application}
      valueName={sfParameters.unit}
      validation={validation}
      groupingOptionsEndpoint={endpoints.responsibleForUnit.caseType}
      valuesOptionsEndpoint={endpoints.responsibleForUnit.unit}
      groupingLabel={translation.case_type}
      valueLabel={selectedGroupText({ selectedGroup, translation })}
      clearValueInStore={clearValueInStore}
      clearValidation={clearValidation}
      useLabelOption={true}
      singleStepAccess={false}
      addButtonText={translation.add_case_type_button_text}
      addSubButtonText={translation.add_units_button_text}
      options={options}
      loadOptions={loadOptions}
      displaySelectAll={true}
      selectedGroup={selectedGroup}
      extraFooterButton={manageOptionsUnit(translation.manage_options)}
    />
  </AdminPaperTopPanel>;
};
